import { useOrderSuspense } from '../api/get-order';
import { formatDate, formatMobileNumber } from '@/utils/shared/formatters';
import { FlyoutRow, FlyoutSection, FlyoutSectionDivider } from '@/shared/components/flyout';
import { calculateTotalQuantity } from '../utils/order-items';
import { NotepadText } from 'lucide-react';
import { OrderStatusBadge } from './order-status-badge';
import { formatMoney } from '@/utils/shared/Utils';
import { Switch } from '@/shared/components/ui/switch';
import { useDeliverOrder } from "../api/deliver-order";
import { useUndeliverOrder } from "../api/undeliver-order";

export function OrderPanel({ orderId }: { orderId: string }) {
  const { data: order } = useOrderSuspense({ orderId });
  const deliverOrder = useDeliverOrder();
  const undeliverOrder = useUndeliverOrder();
  const customerName = `${order.customer.firstName} ${order.customer.lastName}`;

  return (
    <div className="max-w-sm mx-auto lg:max-w-none flex flex-col gap-6 mb-20">
      <div>
        <div className="text-gray-800 dark:text-gray-100 font-semibold text-center mb-1">Beställning</div>

        <div className="text-sm text-center italic">{formatDate(order.createdAt)}</div>
      </div>

      {/* Main Section */}
      <div className="drop-shadow-md mt-10">
        <FlyoutSection className="rounded-b-sm drop-shadow-none flex flex-col items-center">
          <div className="size-24 inline-flex p-4 bg-white border-ring rounded-full -mt-16">
            <NotepadText className="text-primary size-16" />
          </div>
          <h3 className="text-base font-medium text-gray-800 dark:text-gray-100 mb-3">{customerName}</h3>
          <OrderStatusBadge status={order.status} />
        </FlyoutSection>

        <FlyoutSectionDivider />

        <FlyoutSection className="rounded-t-sm">
          <FlyoutRow label="Belopp">{formatMoney(order.totalAmount)}</FlyoutRow>
          <FlyoutRow label="Produkter">{calculateTotalQuantity(order.orderItems)} st</FlyoutRow>
          {/*<FlyoutRow label="Levererad">
            <Switch />
          </FlyoutRow>*/}
        </FlyoutSection>
      </div>

      {/* Customer */}
      <FlyoutSection label="Kund">
        <FlyoutRow label="Namn">{customerName}</FlyoutRow>
        <FlyoutRow label="E-post">{order.customer.email}</FlyoutRow>
        <FlyoutRow label="Mobilnummer">{formatMobileNumber(order.customer.mobileNumber)}</FlyoutRow>
      </FlyoutSection>

      {/* Shipping address */}
      <FlyoutSection label="Leveransadress">
        <FlyoutRow label="Gatuadress">{order.shippingAddress.street}</FlyoutRow>
        <FlyoutRow label="Postnummer">{order.shippingAddress.postalCode}</FlyoutRow>
        <FlyoutRow label="Postort">{order.shippingAddress.city}</FlyoutRow>
      </FlyoutSection>

      {/* Items */}
      <FlyoutSection label="Produkter">
        {order.orderItems.map((item) => (
          <FlyoutRow label={item.productName}>{`${item.quantity} st`}</FlyoutRow>
        ))}
      </FlyoutSection>
    </div>
  );
}
